
export enum BuyingMethodKey {
    /** 买币 */
    Coins = 'coins',
    /** 充值 */
    Invest = 'invest',
    /** 划转 */
    Transfer = 'transfer',
}
